import Header from "../components/Header";
import UserCard from "../components/UserCard"; 

const Home = () => {

    return(
        <div className="home"> 
            <Header />
            <UserCard /> 
            
        </div>
    )
}

export default Home; 